export default [
  {
    path: '/vip/preferential',
    name: 'vip_preferential',
    meta: {
      title: '省钱账单'
    },
    component: () => import('views/vip/preferential')
  },
  {
    path: '/vip/comment_list',
    name: 'vip_comment_list',
    meta: {
      title: '会员之声'
    },
    component: () => import('views/vip/comment_list')
  },
  {
    path: '/vip/exchange',
    name: 'vip_exchange',
    meta: {
      title: 'VIP会员兑换'
    },
    component: () => import('views/vip/exchange')
  },
  {
    path: '/vip/policy',
    name: 'vip_policy',
    meta: {
      title: '孕橙增值服务协议'
    },
    component: () => import('views/vip/policy')
  },
  {
    path: '/vip/member_price',
    name: 'member_price',
    meta: {
      title: 'VIP畅享精选商品会员价'
    },
    component: () => import('views/vip/member_price')
  },
  {
    path: '/vip/unlock_lh',
    name: 'unlock_lh',
    meta: {
      title: '解锁智能排卵预测功能'
    },
    component: () => import('views/vip/unlock_lh')
  },
  {
    path: '/vip/vip_introduce',
    name: 'vip_introduce',
    meta: {
      title: '升级VIP提升好孕率'
    },
    component: () => import('views/vip/vip_introduce')
  }
]